import { Injectable, EventEmitter } from '@angular/core';
import { EnvironmentService } from "@nw/ui-core-shared/services";
import { MainStoreService } from '@nw/ui-core-shared/store/main-store.service';

@Injectable()
export class VehicleLiveblockAuctionService {

    private showAutobidMobileViewHandler: EventEmitter<any> = new EventEmitter();
    constructor() {
    }

    showJoinMobileView(vehicle){
        this.showLiveblockAuctionMobileView(vehicle, false);
    }

    showAutobidMobileView(vehicle){
        this.showLiveblockAuctionMobileView(vehicle, true);
    }

    private showLiveblockAuctionMobileView(vehicle$, showAutobidMobileView$) {
        this.showAutobidMobileViewHandler.emit({ vehicle: vehicle$, showAutobidMobileView: showAutobidMobileView$});
    }
    getLiveblockAuctionMobieView() {
        return this.showAutobidMobileViewHandler;
    }
}



// WEBPACK FOOTER //
// ./node_modules/@nw/ui-watchlist/shared/services/vehicle-liveblock-auction.service.ts